(ns nl.mediquest.questionnaire-frontend.routes
  (:require
   [nl.mediquest.lib.router :as mq-lib.router]
   [re-frame.core :as re-frame]))

(def routes
  ["/" {"" :home
        "privacy" :privacy
        ["menu/" :questionnaire/menu-id]
        {#"/?" :menu
         ["/" :questionnaire/questionnaire-deployment-id] :menu}
        [:questionnaire/questionnaire-id]
        {#"/?" :landingspage
         ["/" :questionnaire/questionnaire-deployment-id]
         {"" :questionnaire
          "/unavailable" :deployment-unavailable
          "/status" :deploy-status
          "/unsubscribe" :unsubscribe
          "/report" {"/?" :result
                     ["/" :report/url-path] :result}}}
        true :bad-url}])

(defn- panel-name
  [matched-route]
  (keyword (str (name (:handler matched-route)) "-panel")))

(re-frame/reg-event-fx
 ::mq-lib.router/on-page-change
 (fn [_ [_ _route matched-route]]
   {:fx [[:dispatch [:nl.mediquest.questionnaire-frontend.events/new-active-panel
                     (panel-name matched-route)
                     (:route-params matched-route)]]]}))

(defn app-routes []
  (mq-lib.router/setup-history-listener! routes))
